// Nimutech — scripts propios. Vanilla JS, sin librerías externas.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initFaq();
  initGaleriaHover();
  initProductoGaleria();
  initProductoVariantes();
});

// ---------- reveals al hacer scroll ----------
function initReveal() {
  var els = document.querySelectorAll('.nmt-reveal');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('nmt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nmt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

// ---------- cifras animadas ----------
function initCountUp() {
  var els = document.querySelectorAll('[data-nmt-countup]');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-nmt-countup')) || 0;
        var decimals = (el.getAttribute('data-nmt-countup').split('.')[1] || '').length;
        observer.unobserve(el);
        if (reduce) { el.textContent = target.toFixed(decimals); return; }
        var start = null;
        var duration = 1400;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

// ---------- FAQ acordeón ----------
function initFaq() {
  var items = document.querySelectorAll('.nmt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var q = item.querySelector('.nmt-faq-q');
    var a = item.querySelector('.nmt-faq-a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      items.forEach(function (other) {
        other.classList.remove('is-open');
        var otherA = other.querySelector('.nmt-faq-a');
        if (otherA) otherA.style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('is-open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });
}

// ---------- hover de galería multi-ángulo (placeholder de interacción) ----------
function initGaleriaHover() {
  var items = document.querySelectorAll('.nmt-galeria-item');
  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () { item.classList.add('is-hover'); });
    item.addEventListener('mouseleave', function () { item.classList.remove('is-hover'); });
  });
}

// ---------- galería de la página de producto ----------
function initProductoGaleria() {
  var main = document.querySelector('[data-nmt-p-main]');
  var thumbs = document.querySelectorAll('[data-nmt-p-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-nmt-p-thumb');
      var srcset = thumb.getAttribute('data-nmt-p-thumb-srcset');
      main.src = src;
      if (srcset) main.srcset = srcset;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
}

// ---------- selector de variantes de producto ----------
function initProductoVariantes() {
  var form = document.querySelector('[data-nmt-p-form]');
  if (!form) return;
  var variantsEl = document.querySelector('[data-nmt-p-variants]');
  if (!variantsEl) return;
  var variants;
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch (e) { return; }

  var optionButtons = form.querySelectorAll('[data-nmt-p-optvalue]');
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-nmt-p-price]');
  var compareEl = document.querySelector('[data-nmt-p-compare]');
  var submitBtn = form.querySelector('[data-nmt-p-submit]');
  var stockEl = document.querySelector('[data-nmt-p-stock]');

  var selected = {};
  form.querySelectorAll('[data-nmt-p-optvalue].is-selected').forEach(function (btn) {
    selected[btn.getAttribute('data-nmt-p-optname')] = btn.getAttribute('data-nmt-p-optvalue');
  });

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (val, i) {
        var optName = v.optionNames ? v.optionNames[i] : null;
        return optName ? selected[optName] === val : true;
      });
    });
  }

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
    });
  }

  function update() {
    var variant = findVariant();
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available
        ? submitBtn.getAttribute('data-nmt-p-label-add')
        : submitBtn.getAttribute('data-nmt-p-label-soldout');
    }
    if (stockEl) {
      stockEl.style.display = variant.available ? '' : 'none';
    }
  }

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var name = btn.getAttribute('data-nmt-p-optname');
      form.querySelectorAll('[data-nmt-p-optname="' + name + '"]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      selected[name] = btn.getAttribute('data-nmt-p-optvalue');
      update();
    });
  });

  update();
}
